import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGetSection() {
  const deliverables = [{
    title: 'El Plan Maestro de 7 Días',
    description: 'Menú detallado de desayuno, almuerzo y cena con sabor de casa.'
  }, {
    title: 'La Regla del 1-2-3',
    description: 'Cómo preparar tu café matutino para que sepa a postre pero queme grasa.'
  }, {
    title: 'Mapa de Supermercado en USA',
    description: 'Lista de marcas "seguras" y cuáles evitar en Walmart, Costco y Publix.'
  }, {
    title: 'Guía de Supervivencia en Fiestas',
    description: 'Cómo ir a un "party" familiar o restaurante sin romper tu progreso.'
  }, {
    title: 'Lista de Compras "Zero Inflamación"',
    description: 'Para que vayas al súper con tiro fijo y ahorres dinero.'
  }];
  return <section className="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-169">
      <FadeIn data-id="element-170">
        <div className="text-center mb-16" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-brown mb-4" data-id="element-172">
            LO QUE RECIBIRÁS CON TU GUÍA DIGITAL:
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-173"></div>
        </div>
      </FadeIn>

      <div className="space-y-6" data-id="element-174">
        {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-175">
            <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-l-terracotta flex items-start space-x-4 md:space-x-6 hover:shadow-md transition-shadow" data-id="element-176">
              <CheckCircle2 className="w-8 h-8 text-cinnamon flex-shrink-0 mt-1" data-id="element-177" />
              <div data-id="element-178">
                <h3 className="text-xl font-bold text-dark-brown mb-2" data-id="element-179">
                  {item.title}
                </h3>
                <p className="text-lg text-dark-brown/70" data-id="element-180">{item.description}</p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}